import { Edit, ListButton, TopToolbar } from 'react-admin';
import ChevronLeft from '@material-ui/icons/ChevronLeft';

import OccupationForm from './OccupationForm';

const OccupationActions = ({ basePath }: any) => (
  <TopToolbar>
    <ListButton
      basePath={basePath}
      label='ra.action.back'
      icon={<ChevronLeft />}
    />
  </TopToolbar>
);

const OccupationEdit = (props: any) => {
  return (
    <Edit actions={<OccupationActions {...props} />} {...props}>
      <OccupationForm />
    </Edit>
  );
};

export default OccupationEdit;
